
<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Banner">
  <div class="image-text">
    <p>Contact Us</p>
  </div>
</div>

<div class="bg-white" style="height: 10vh;"></div>

<app-contact-us></app-contact-us>
